import React, { useContext } from 'react'
import { Box } from '@material-ui/core'
import EasyPayPlanWithOptionCard from './EasyPayPlanWithOptionCard'
import EasyPayPlanWithoutOptionCard from './EasyPayPlanWithoutOptionCard'
import { BOOKING_FLEXIBILITY_STATUS } from '../../../constants'
import { Context } from '../../../Store'
import { ErrorMessage } from '../Forms/ErrorMessage'
import { isMobile } from 'react-device-detect'

export default function EasyPayPlanOptionsGroup() {
  const [state, dispatch] = useContext(Context)

  const handleChange = (value) => {
    dispatch({
      type: 'SET_FLEXIBILITY_STATUS',
      payload: value,
    })
  }

  return (
    <Box
      style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, 1fr)',
        gap: 16, 
        alignItems: 'stretch',
        width: '100%',
      }}
    >
      <div style={{ display: 'flex' }}>
        <div style={{ flex: 1, display: 'flex' }}>
          <EasyPayPlanWithOptionCard
            checked={state.flexibility_status === BOOKING_FLEXIBILITY_STATUS.READY}
            onChange={() => handleChange(BOOKING_FLEXIBILITY_STATUS.READY)}
          />
        </div>
      </div>

      <div style={{ display: 'flex' }}>
        <div style={{ flex: 1, display: 'flex' }}>
          <EasyPayPlanWithoutOptionCard checked={state.flexibility_status === null} onChange={() => handleChange(null)} />
        </div>
      </div>
      {state?.error?.flexibility_status && <ErrorMessage error={state?.error?.flexibility_status} />}
    </Box>
  )
}
